"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolUnerlyingCurrencyFromInstrumentString = exports.isLinearLikeInstrument = exports.isOptionLikeInstrument = exports.isFutureLikeInstrument = exports.getSettlementCurrencyFromInstrumentString = exports.getQuoteCurrencyFromInstrumentString = exports.getBaseCurrencyFromInstrumentString = exports.getInstrumentType = void 0;
const types_1 = require("../types");
const settlementCurrencyFns = {
    FUTURE: (instrument) => {
        return instrument.split("-")[0];
    },
    OPTION: (instrument) => {
        return instrument.split("-")[0];
    },
    LINEAR_FUTURE: (instrument) => {
        return types_1.Currency.USDC;
    },
    LINEAR_OPTION: (instrument) => {
        return types_1.Currency.USDC;
    },
    LINEAR_PERPETUAL: (instrument) => {
        return types_1.Currency.USDC;
    },
    VOLATILITY_FUTURE: (instrument) => {
        return types_1.Currency.USDC;
    },
    INVERSE_PERPETUAL: (instrument) => {
        return instrument.split("-")[0];
    },
};
const baseCurrencyFns = {
    FUTURE: (instrument) => {
        return instrument.split("-")[0];
    },
    OPTION: (instrument) => {
        return instrument.split("-")[0];
    },
    LINEAR_FUTURE: (instrument) => {
        return instrument.split("-")[0].split("_")[0];
    },
    LINEAR_OPTION: (instrument) => {
        return instrument.split("-")[0].split("_")[0];
    },
    LINEAR_PERPETUAL: (instrument) => {
        return instrument.split("-")[0].split("_")[0];
    },
    VOLATILITY_FUTURE: (instrument) => {
        return instrument.split("-")[0].split("_")[0];
    },
    INVERSE_PERPETUAL: (instrument) => {
        return instrument.split("-")[0];
    },
};
const quoteCurrencyFns = {
    FUTURE: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    OPTION: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    LINEAR_FUTURE: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    LINEAR_OPTION: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    LINEAR_PERPETUAL: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    VOLATILITY_FUTURE: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
    INVERSE_PERPETUAL: (instrument) => {
        return instrument.includes("USDC") ? types_1.Currency.USDC : types_1.Currency.USD;
    },
};
/**
 * Idea: change to instruments with regex and mask. Eg: 'xxx_usdc-nnxxxnn' is linear future. It
 * was easy with two types but now this became complicated.
 */
const getInstrumentType = (instrument) => {
    const instrumentParts = instrument.split("-");
    if (instrumentParts.length === 4) {
        return instrumentParts[0].includes("USDC")
            ? types_1.PositionType.LinearOption
            : types_1.PositionType.Option;
    }
    else {
        if (instrument.includes("DVOL")) {
            return types_1.PositionType.VolatilityFuture;
        }
        if (instrument.split("_")[1] === "USDC-PERPETUAL") {
            return types_1.PositionType.LinearPerpetual;
        }
        if (instrument.includes("_USDC")) {
            return types_1.PositionType.LinearFuture;
        }
        return types_1.PositionType.Future;
        // TODO: This way if combo or somehitng else comes it will be treated as a future. Best to default to undefined
    }
};
exports.getInstrumentType = getInstrumentType;
const getBaseCurrencyFromInstrumentString = (instrument) => {
    return baseCurrencyFns[(0, exports.getInstrumentType)(instrument)](instrument);
};
exports.getBaseCurrencyFromInstrumentString = getBaseCurrencyFromInstrumentString;
const getQuoteCurrencyFromInstrumentString = (instrument) => {
    return quoteCurrencyFns[(0, exports.getInstrumentType)(instrument)](instrument);
};
exports.getQuoteCurrencyFromInstrumentString = getQuoteCurrencyFromInstrumentString;
const getSettlementCurrencyFromInstrumentString = (instrument) => {
    return settlementCurrencyFns[(0, exports.getInstrumentType)(instrument)](instrument);
};
exports.getSettlementCurrencyFromInstrumentString = getSettlementCurrencyFromInstrumentString;
const isFutureLikeInstrument = (instrument) => {
    const positionType = (0, exports.getInstrumentType)(instrument);
    return (positionType === types_1.PositionType.Future ||
        positionType === types_1.PositionType.LinearFuture ||
        positionType === types_1.PositionType.LinearPerpetual ||
        positionType === types_1.PositionType.VolatilityFuture);
};
exports.isFutureLikeInstrument = isFutureLikeInstrument;
const isOptionLikeInstrument = (instrument) => {
    const positionType = (0, exports.getInstrumentType)(instrument);
    return (positionType === types_1.PositionType.Option ||
        positionType === types_1.PositionType.LinearOption);
};
exports.isOptionLikeInstrument = isOptionLikeInstrument;
const isLinearLikeInstrument = (instrument) => {
    const positionType = (0, exports.getInstrumentType)(instrument);
    return (positionType === types_1.PositionType.LinearFuture ||
        positionType === types_1.PositionType.LinearPerpetual ||
        positionType === types_1.PositionType.VolatilityFuture ||
        positionType === types_1.PositionType.LinearOption);
};
exports.isLinearLikeInstrument = isLinearLikeInstrument;
const getVolUnerlyingCurrencyFromInstrumentString = (instrument) => {
    return instrument.substring(0, 3);
};
exports.getVolUnerlyingCurrencyFromInstrumentString = getVolUnerlyingCurrencyFromInstrumentString;
